export default __webpack_public_path__ + "static/media/creativityFestival3.35cd478b.png";